import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found - Bungen Lee</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <section className="not-found">
        <div className="container">
          <div className="not-found-content card">
            <div className="not-found-icon">
              <i className="fas fa-exclamation-triangle"></i>
            </div>
            <h2>Page Not Found</h2>
            <p>The page you're looking for doesn't exist or has been moved.</p>
            <Link to="/" className="btn btn-primary">
              <i className="fas fa-home"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </section>

      <style jsx>{`
        .not-found {
          padding: 6rem 0;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 60vh;
        }
        
        .not-found-content {
          text-align: center;
          max-width: 500px;
          margin: 0 auto;
          padding: 4rem 2rem;
        }
        
        .not-found-icon {
          font-size: 4rem;
          margin-bottom: 2rem;
          background: var(--gradient-gold);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        .not-found-content h2 {
          margin-bottom: 1rem;
        }
        
        .not-found-content p {
          margin-bottom: 2rem;
          font-size: 1.1rem;
        }
      `}</style>
    </>
  );
};

export default NotFound;